import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';

import {Subscription} from 'rxjs';

import {Survey} from '../../api/models/survey';
import {User} from '../../api/models/user';

import {AuthService} from '../../api/services/auth.service';
import {SurveyService} from '@app/api/services/survey.service';
import {MessageService} from '@app/api/services/message.service';
import {base} from '@app/api/api-config';
import {
  WaBreadcrumbDirective,
  WaBreadcrumbItemDirective,
  WaButtonDirective,
  WaDividerDirective,
  WaDropdownDirective, WaDropdownItemDirective,
  WaIconDirective
} from "angular-awesome";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaIconDirective, WaBreadcrumbDirective, WaBreadcrumbItemDirective, WaDropdownDirective, WaButtonDirective, WaDividerDirective, WaDropdownItemDirective]
})
export class NavbarComponent implements OnDestroy {

  private userSub: Subscription;
  private surveySub: Subscription;

  user: User | null = null;
  survey: Survey | null = null;

  constructor(private router: Router,
              private authService: AuthService,
              private msgService: MessageService,
              private surveyService: SurveyService) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => {
        this.user = user;
        this.authService.refresh(false);
      },
      error: err => {
        this.msgService.log(err.message);
        this.msgService.showSimple('Could not fetch logged in user.');
      }
    });

    this.surveySub = this.surveyService.selectedSurvey$.subscribe({
      next: survey => this.survey = survey,
      error: err => {
        this.msgService.log(err.message);
        this.msgService.showSimple('Could not fetch selected survey');
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
    this.surveySub.unsubscribe();
  }

  onLoginView(): boolean {
    return this.router.url === '/login';
  }

  onPrivacyView(): boolean {
    return this.router.url === '/privacy';
  }

  onImprintView(): boolean {
    return this.router.url === '/imprint';
  }

  atHome(): boolean {
    return this.router.url === '/home';
  }

  shibboleth_login(): void {
    if (!!this.user) return;
    window.location.href = `${base}/shib-login`;
  }

  guest_login(): void {
    if (!!this.user) {
      console.log("User logged in!")
      return;
    }
    this.router.navigateByUrl('login');
  }

  goToPrivacyView(): void {
    if (this.onPrivacyView()) return;
    this.router.navigateByUrl('privacy');
  }

  goToImprintView(): void {
    if (this.onImprintView()) return;
    this.router.navigateByUrl('imprint');
  }

  goHome(): void {
    if (this.atHome()) return;
    this.router.navigateByUrl('home');
  }

  getUserFullName(): string {
    return this.user ? `${this.user.first_name} ${this.user.last_name}` : '';
  }

  logout(): void {
    this.authService.logout();
  }
}
